import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const vehicleApi = createApi({
  reducerPath: "vehicleApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ['vehicle'],
  endpoints: builder => ({
    updateCustomerVehicleDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.CustomerVehicleController.updateCustomerVehicleDetail,
          method: 'POST',
          headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
          body: body.payload,
        };
      },
    }),

    saveCustomerVehicleDetail: builder.mutation({
        query(body) {
          return {
            url: spotFinder.CustomerVehicleController.saveCustomerVehicleDetail,
            method: 'POST',
            headers: body.token ? {Authorization: `Bearer ${body.token}`} : {},
            body: body.payload,
          };
        },
      }),
      searchCustomerVehicleDetail: builder.mutation({
        query: body => {
          return {
            url: spotFinder.CustomerVehicleController.searchCustomerVehicleDetail,
            method: 'POST',
            body: body.payload,
            headers: {Authorization: `Bearer ${body.token}`},
          };
        },
      }),
      deleteCustomerVehicleDetail: builder.mutation({
        query(body) {
          return {
            url: `${spotFinder.CustomerVehicleController.deleteCustomerVehicleDetail}${body.id}`,
            method: 'DELETE',
            headers: { Authorization: `Bearer ${body.token}` },
          };
        },
      }),
  }),
});

export const { useSaveCustomerVehicleDetailMutation, useUpdateCustomerVehicleDetailMutation , useSearchCustomerVehicleDetailMutation ,useDeleteCustomerVehicleDetailMutation} = vehicleApi;
